namespace advisorop.components.servicer {

    export class CuRepFeeGroupServicerController {

        $router;

        public model: Array<domains.IRepFeeGroup>;
        public dg: DevExpress.ui.dxDataGridOptions;
        n: number;
        repFeeGroup: domains.IRepFeeGroup;
        isInEditState: boolean = false;
        advisorFirm: number;
        companyGroup: domains.ICompanyGroup;
        companyGroupId: number;

        allocation: domains.RepFeeGroupAllocation = new domains.RepFeeGroupAllocation();
        dgAllocationAdvisorSettings: DevExpress.ui.dxDataGridOptions;
        selectedAdvisor: domains.IAdvisor = null;
        availableFeePercentage = 1;
        adv: domains.IAdvisor = {};
        user: domains.identity.IUser = {};

        static $inject = ["repGroupApi", "identityService", "servicerService"];
        constructor(private repGroupApi: services.RepGroupApi,
            private identityService: services.IdentityService, private servicerService: services.ServicerService) {

            this.repFeeGroup = {
                allocations: []
            };



            this.allocation.percentage = this.availableFeePercentage;

            this.dgAllocationAdvisorSettings = {
                export: {
                    enabled: true,
                    fileName: "RepFeeGroupAllocations"
                },
                bindingOptions: {
                    dataSource: "vm.repFeeGroup.allocations"
                    //,"columns[0].lookup.dataSource": "vm.investmentModels"
                },
                //height: "350px",
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "No allocated advisors for this rep fee group",
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgInvestmentSettings"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                //editing: {
                //    mode: "row",
                //    allowUpdating: true,
                //    allowDeleting: true,
                //    allowAdding: true
                //}, 
                columns: [
                    { dataField: "advisor.fullName", caption: "Advisor", visible: true },
                    { dataField: "advisor.repNumber", caption: "Rep Number", visible: true, width: 100 },
                    { dataField: "percentage", caption: "Percentage", format: { type: "percent", precision: 2 }, visible: true, width: 100 },
                    { dataField: "houseSplit", caption: "House Split", format: { type: "percent", precision: 2 }, visible: true, width: 100 },
                    { dataField: "id", caption: "#", cellTemplate: "btnActions", width:"35" }
                ]
            };

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "RepFeeGroups"
                },
                bindingOptions: {
                    dataSource: "vm.model"
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                noDataText: "No Rep Fee Groups",
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: "dgAlertLogs"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "dateCreated", dataType: "date", format: "shortDateShortTime", caption: "Created", width: 150 },
                    { dataField: "name", caption: "Name" },
                    { dataField: "repNumber", caption: "Rep Number", visible: true},
                    { dataField: "systemLoginCreated.fullName", caption: "Created by",width: 160  },
                    { dataField: "id", caption: "Actions", cellTemplate: "colActions", width: 160 }
                ]
            };
        }

        initNewRepFeeGroup() {
            this.availableFeePercentage = 1;
            this.allocation.percentage = 1;
            this.isInEditState = true;
        }

        newAdvisorSelected(advisor: domains.IAdvisor): void {
            this.selectedAdvisor = advisor;
            this.allocation.houseSplit = advisor.defaultHouseSplit;

        };

        decrementAvailablePercentage(percentage: number) {

            this.availableFeePercentage = this.availableFeePercentage - percentage;

            if (this.availableFeePercentage < 0)
                this.availableFeePercentage = 0;
            else if (this.availableFeePercentage > 1)
                this.availableFeePercentage = 1;
        };


        addAdvisorAllocation(): void {
            if (!this.selectedAdvisor || !(this.selectedAdvisor.id > 0)) {

                toastr.error("Please select advisor.");

                return;
            }

            if (this.repFeeGroup.allocations.filter((v) => {
                return v.advisorId == this.selectedAdvisor.id;
            }).length > 0) {
                toastr.warning("Advisor is already contained by this group, please select another advisor");
                return;
            }

            if (this.allocation.percentage < 0 || this.allocation.percentage > 1) {
                toastr.error("Percentage must be greeater then 0% and less then 100%");
                return;
            }

            if (this.allocation.houseSplit < 0 || this.allocation.houseSplit > 1) {
                toastr.error("Housesplit must be greeater then 0% and less then 100%");
                return;
            }

            this.allocation.advisor = {};

            angular.copy(this.selectedAdvisor, this.allocation.advisor);

            this.allocation.advisorId = this.selectedAdvisor.id;

            this.allocation.repFeeGroupId = this.repFeeGroup.id;

            if (this.availableFeePercentage - this.allocation.percentage < 0)
            {
                toastr.warning("Total percentage cannot be greater then 100%");
                return;
            }

            this.decrementAvailablePercentage(this.allocation.percentage);
            
            var tmpAllocation: domains.RepFeeGroupAllocation = new domains.RepFeeGroupAllocation();

            angular.copy(this.allocation, tmpAllocation);

            // ADD TO ALLOCATIONS
            this.repFeeGroup.allocations.push(tmpAllocation);

            this.allocation = new domains.RepFeeGroupAllocation();
            this.allocation.percentage = this.availableFeePercentage;
            //this.allocation.houseSplit = this.adv.defaultHouseSplit;

            this.selectedAdvisor = null;
        };

        removeAdvisorFromAllocationList(allocation: domains.IRepFeeGroupAllocation): void {
            var ind = this.repFeeGroup.allocations.indexOf(allocation);

            if (ind >= 0) {
                this.decrementAvailablePercentage(-this.repFeeGroup.allocations[ind].percentage);                
                this.allocation.percentage = this.availableFeePercentage;
                this.repFeeGroup.allocations.splice(ind, 1);
            }
        };
        
        //Create Rep Fee Group
        createRepFeeGroup(repFeeGroup: domains.IRepFeeGroup): void {
            this.repFeeGroup.id = 0;
            this.repFeeGroup.companyGroupId = this.companyGroupId;
            this.repGroupApi.create(this.repFeeGroup)
                    .success((data) => {

                        toastr.success("Group successfully added.");

                        this.repFeeGroup.id = data.id;
                        this.isInEditState = false;
                        this.repFeeGroup = {
                            allocations: []
                        };
                        this.availableFeePercentage = 1;
                        this.allocation.percentage = this.availableFeePercentage;
                        this.loadRepFeeGroups(this.companyGroupId);

                    }).error((data, status) => {
                        toastr.error("Error " + status + " : " + data);
                    });
        };

        //Update Rep Fee Group
        updateRepFeeGroup(repFeeGroup: domains.IRepFeeGroup): void {
            this.repGroupApi.update(repFeeGroup)
                    .success((data) => {

                        toastr.success("Group has been successfully updated.");

                        this.repFeeGroup.id = data.id;
                        this.loadRepFeeGroups(this.companyGroupId);
                    })
                    .error((status, data) => {
                        toastr.error("Error " + status + " " + data);
                        return;
                    })
                    .finally(() => {
                        this.isInEditState = false;
                        this.repFeeGroup = {
                            allocations: []
                        };

                    });
        };

        //Get Rep Fee Group By Id

        getRepFeeGroupById(repFeeGroupId: number): void {
            this.isInEditState = true;
            this.availableFeePercentage = 1;



            this.repGroupApi.getById(repFeeGroupId)
                    .then(data => {
                        this.repFeeGroup = data.data;
                        var sumOfPercents: number = 0;
                        for (var i = 0; i <= this.repFeeGroup.allocations.length - 1; i++) {
                            sumOfPercents = sumOfPercents + this.repFeeGroup.allocations[i].percentage;
                        }
                        this.decrementAvailablePercentage(sumOfPercents);
                        this.allocation.percentage = this.availableFeePercentage;
                    }).
                    catch(error => {
                        toastr.error("Can not find this group" + error.status + " " + error.data);
                    })
        };

        cancel(): void {
           // this.allocation.houseSplit = this.adv.defaultHouseSplit;

            this.allocation.houseSplit = 0;

            this.isInEditState = false;

            this.repFeeGroup = {};

            this.selectedAdvisor = null;

            this.availableFeePercentage = 1;

            this.allocation.percentage = this.availableFeePercentage;

            this.loadRepFeeGroups(this.companyGroupId);
        };

        loadRepFeeGroups(companyGroupId: number): void {
            this.repGroupApi
                .filterByOption(domains.RepGroupFeeOptions.BOTH, companyGroupId)
                .then(data => {
                    this.model = data.data;
                }, err => {
                    toastr.error("Rep Fee Group list error: " + err.status + ":" + err.data);
                });
        };


        //Delete Rep Fee Group
        deleteRepFeeGroup(repFeeGroup: domains.IRepFeeGroup): void {

            if (!confirm("Would you realy like to delete " + repFeeGroup.name + " repfee group?"))
                return;

            var x = this.model;

            this.repGroupApi.deleteRepGroup(repFeeGroup.id)
                    .then(data => {
                        toastr.success("Group deleted.");
                        var ind = x.indexOf(repFeeGroup);
                        if (ind >= 0) {
                            x.splice(ind, 1);
                        }
                    })
                    .catch(error => {
                        toastr.error("Could not delete this group. Error:" + error.status + " " + error.data);
                    });
            
        };

        $onInit() {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.adv = this.user.advisor;
            });
            this.loadRepFeeGroups(this.companyGroupId);
        }

        $routerOnActivate(next, previous) {
           
        }

    }

    class CuRepFeeGroupServicer implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<",
                advisor: "<",
                companyGroupId: "<"
            };
            this.controller = CuRepFeeGroupServicerController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/cu-rep-fee-group-servicer.html";
        }
    }
    angular.module(Constants.APP).component("cuRepFeeGroupServicer", new CuRepFeeGroupServicer());

}